import React from "react";
import { Outlet, Link } from "react-router-dom";
import "./DashboardLayout.css";

export default function DashboardLayout() {
    return (
        <div className="dashboard-layout-container">
            <aside className="dashboard-sidebar">
                <h2>Dashboard</h2>
                <nav>
                    <Link to="/dashboard">Home</Link>
                    <Link to="/dashboard/blog-list">Blog Post List</Link>
                    <Link to="/dashboard/add-blog">Post Blog</Link>
                </nav>
            </aside>

            <main className="dashboard-content">
                <Outlet />
            </main>
        </div>
    );
}
